import styled from 'styled-components';

export const TooltipContentStyled = styled.div`
  &.tooltip-container {
    box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
    border-radius: 8px;
    color: #515151;
    border: none;
    font-size: 14px;
    font-weight: 500;
    max-width: 335px;
  }
`;

export const ElementWrapperStyled = styled.button`
  flex: none;
`;
